export type Permissions = Array<{ key: string; active: boolean }>

export const hasSourcePullRequestPermission = (permissions: Permissions) =>
  Boolean(
    permissions.find(permission => permission.key === "pull_requests")?.active
  )

export function getPreviewWebhookUrl(siteId: string) {
  return `${process.env.GATSBY_WEBHOOK_URL}/hooks/data_source/${siteId}`
}

export function getBuildWebhookUrl(siteId: string) {
  return `${process.env.GATSBY_WEBHOOK_URL}/hooks/data_source/publish/${siteId}`
}

export function getContentLoaderUrl(siteId: string) {
  return `${process.env.GATSBY_DASHBOARD_URL}/content-sync/${siteId}`
}
